import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['activeIndicator', 'link']
  static values = { scrollContainer: String }

  connect() {
    const scrollContainer = this.hasScrollContainerValue
      ? document.querySelector(this.scrollContainerValue)
      : null

    // Listen to both the specified container and the window. On desktop the
    // container scrolls. On mobile the window scrolls instead.
    this.scrollTargets = scrollContainer ? [scrollContainer, window] : [window]

    this.headings = this.linkTargets
      .map(link => document.querySelector(link.getAttribute('href')))
      .filter(el => el !== null)

    this.boundUpdateActiveItem = this.#updateActiveItem.bind(this)

    this.scrollTargets.forEach(target =>
      target.addEventListener('scroll', this.boundUpdateActiveItem)
    )

    this.#updateActiveItem()
  }

  disconnect() {
    this.scrollTargets.forEach(target =>
      target.removeEventListener('scroll', this.boundUpdateActiveItem)
    )
  }

  #repositionIndicator() {
    const activeLink = this.linkTargets.find(
      link => link.dataset.active === 'true'
    )

    if (!activeLink) return

    const rect = activeLink.getBoundingClientRect()

    this.#updateIndicatorPosition(
      rect.height,
      rect.top - this.element.getBoundingClientRect().top
    )
  }

  #setActiveLink(activeId) {
    this.linkTargets.forEach(link => {
      link.dataset.active = link.getAttribute('href') === `#${activeId}`
    })

    this.#repositionIndicator()

    // Some text will wrap after becoming active due to font-weight increasing
    // and thus change in height. After item height transitions complete,
    // snap-correct the indicator position
    clearTimeout(this.repositionTimer)

    this.repositionTimer = setTimeout(() => {
      this.activeIndicatorTarget.style.transition = 'none'
      this.#repositionIndicator()

      requestAnimationFrame(() => {
        this.activeIndicatorTarget.style.transition = ''
      })
    }, 200)
  }

  #updateActiveItem() {
    if (!this.headings.length) return

    const THRESHOLD = 100
    let closestHeading = null
    let closestTop = Number.NEGATIVE_INFINITY

    this.headings.forEach(heading => {
      const rect = heading.getBoundingClientRect()

      if (rect.top <= THRESHOLD && rect.top > closestTop) {
        closestTop = rect.top
        closestHeading = heading
      }
    })

    const headingToActivate = closestHeading ?? this.headings[0]
    this.#setActiveLink(headingToActivate.id)
  }

  #updateIndicatorPosition(height, offset) {
    this.activeIndicatorTarget.style.cssText = `
      height: ${height}px;
      translate: 0 ${offset}px;
    `
  }
}
